<template>
<div>
  <tree ref="tree"
        :data="treeData"
        :options="treeOption"
        class="tree"
        @node:dblclick="open"
        @node:selected="selectHandler"
        @node:editing:start="startEditingHandler"
        @node:editing:stop="stopEditingHandler"
        @node:dragging:start="dragStartHandler"
        @node:dragging:finish="dragFinishHandler"
        @keyup.native.enter="enterHandler"

  >
    <div class="tree-line" slot-scope="{ node }">
      <sessionsFileLine v-if="!node.data.isDir" :sessionFile="node.data" />
      <sessionsDirLine v-else :opened="node.expanded()" :dir="node.data" />
    </div>
  </tree>
</div>
</template>

<script>
import sessionsDirLine from './sessionsDirLine.vue'
import sessionsFileLine from './sessionsFileLine.vue'
import {tree as treeUtils} from '../../utils'
import api from "../../api";
const path = require('path')

export default {
  name: "fileTree",
  components: {
    sessionsDirLine,
    sessionsFileLine,
  },
  props: {
    root: String,
  },
  data() {
    return {
      treeData: treeUtils.loadData(this),
      treeNodes: [],
      treeOption: {
        minFetchDelay: 500, // show loading indicator if request takes more than 500ms
        dnd: true,
        checkbox: true,
      },
      curDir: "/",
      curPath: "/",
      curIsDir: "false",

      isEditingNode: false,
      tmpDraggingSrcPath: undefined,
    }
  },
  mounted() {
    let vm = this
    this.$refs.tree.$on('tree:mounted', (t) => {
      setTimeout(() => {treeUtils.selectLatestSelectedItem(t, vm)}, 100)
    })
  },
  beforeDestroy() {
    if (this.isEditingNode === true) this.$emit('isEditingNode', false)
  },
  watch: {
    curDir: function() {
      this.$emit('curDirChanged', this.curDir)
    },
    curPath: function() {
      this.$emit('curPathChanged', this.curPath)
    },
    curIsDir: function() {
      this.$emit('curIsDirChanged', this.curIsDir)
    },
    isEditingNode: function() {
      this.$emit('isEditingNode', this.isEditingNode)
    },
  },
  methods: {
    open(node) {
      treeUtils.isDir(node) ? this.openDir(node) : this.openFile(node)
    },
    openDir(node) {
      console.log("openDir: node:", node)
    },
    openFile(node) {
      let fullPath = treeUtils.node2Path(node)
      this.$emit('connect', fullPath, node.data)
    },
    enterHandler() {
      let selNodes = this.$refs.tree ? this.$refs.tree.selected() : undefined
      if (!selNodes) {
        return
      }
      selNodes.forEach(node => {!treeUtils.isDir(node) ? this.openFile(node) : node.toggleCollapse()})
    },
    // 选中的项目发生变化时调用
    selectHandler(node) {
      let fullPath = treeUtils.node2Path(node)
      // 更新当前路径
      this.curPath = fullPath
      // 更新当前目录

      this.curDir = node.parent === null ? "/" : treeUtils.node2Path(node.parent)

      this.curIsDir = treeUtils.isDir(node)

      // this.$emit('curIsDirChanged', treeUtils.isDir(node))
      // 记录最新的选中项
      treeUtils.setLatestSelectedItem(fullPath)

      this.frameVisibleUpdate(false)
    },
    selectPrev() {
      treeUtils.selectPrevNode(this.$refs.tree)
    },
    selectNext() {
      treeUtils.selectNextNode(this.$refs.tree)
    },
    selectNodeByFullPath(fullPath) {
      treeUtils.selectNodeByFullPath(this.$refs.tree, fullPath, this)
    },
    frameVisibleUpdate(visible) {
      this.$emit('updateFrameVisible', visible)
    },
    expandCurNode() {
      treeUtils.expandCurNode(this.$refs.tree)
    },
    collapseCurNode() {
      treeUtils.collapseCurNode(this.$refs.tree)
    },
    search(pattern) {
      treeUtils.search(this.$refs.tree, pattern)
    },
    deleteSelected() {
      treeUtils.deleteSelectedNodes(this.$refs.tree, this)
    },
    cutSelected() {
      treeUtils.cutSelected(this.$refs.tree, this)
    },
    copySelected() {
      treeUtils.copySelected(this.$refs.tree, this)
    },
    pasteSelection() {
      treeUtils.pasteClipboard(this.$refs.tree, this)
    },
    newDir() {
      treeUtils.newDir(this.$refs.tree, this)
    },
    startEditingHandler(node) {
      // 进入编辑模式
      this.isEditingNode = true
      console.debug("startEditingHandler: editing:", node.text)
    },
    stopEditingHandler(editedNode, oldText) {
      this.isEditingNode = false
      if (editedNode.text === oldText) {
        return
      }

      let vm = this
      let dst = path.join(this.env.sess.basePath, treeUtils.node2Path(editedNode))
      let src = path.join(path.dirname(dst), oldText)
      api.hifs.rename(src, dst, (error, data, response) => {
        if (error) {
          vm.api.errHandler(vm, error, response)
          return
        }
        treeUtils.setLatestSelectedItem(dst)
        vm.$message.success(`rename ${oldText} to ${editedNode.text} success`)
      })
    },
    renameSelectedNode() {
      let selNodes = this.$refs.tree.selected()
      if (!selNodes || selNodes.length < 1) {
        return
      }

      let node = selNodes[0]
      if (!node) {
        return
      }

      node.startEditing()
    },
    dragStartHandler(node) {
      this.tmpDraggingSrcPath = treeUtils.node2Path(node)
    },

    // targetNode: 移动后的 node
    // dstNode: 要移动的 node 的目标节点
    dragFinishHandler(targetNode, dstNode) {
      if (!treeUtils.isDir(dstNode)) {
        this.$message.error(`Invalid destination: ${dstNode.text}`)
        this.$emit("refreshRequest")
        return
      }

      let src = path.join(this.env.sess.basePath, this.tmpDraggingSrcPath)
      let dst = path.join(this.env.sess.basePath, treeUtils.node2Path(targetNode))
      let vm = this
      api.hifs.rename(src, dst, (error, data, response) => {
        if (error) {
          vm.api.errHandler(vm, error, response)
          treeUtils.setLatestSelectedItem(src)
        } else {
          vm.$message.success(`move ${src} to ${dst} success`)
          treeUtils.setLatestSelectedItem(dst)
        }
        vm.$emit("refreshRequest")
      })
    },
    selectCurAllChildren() {
      treeUtils.selectAllChildrenByFullPath(this.$refs.tree, this.curDir)
    },
    checkCurAllChildren() {
      treeUtils.checkAllChildrenByFullPath(this.$refs.tree, this.curDir)
    },
    uncheckCurAllChildren() {
      treeUtils.uncheckAllChildrenByFullPath(this.$refs.tree, this.curDir)
    }
  },
}
</script>

<style scoped>
.tree {
  overflow: auto;
}
.tree-line {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}

/deep/
.tree-checkbox {
  width: 15px;
  height: 15px;
  background-color: #3C3C3C;
  border-color: #777;
}
/deep/
.tree-checkbox.checked {
  background-color: #bbb;
  border-color: #3C3C3C;
}
/deep/
.tree-checkbox.indeterminate {
  background-color: #bbb;
  border-color: #3C3C3C;
}
/deep/
.tree-checkbox.indeterminate:after {
  background-color: #3C3C3C;
}
/deep/
.tree-checkbox.checked:after {
  border-color: #3C3C3C;
}
/deep/
.tree-checkbox.checked::after {
  left: 4px;
  top: 0;
  height: 8px;
  width: 4px;
}
/deep/
.tree-checkbox.indeterminate::after {
  left: 25%;
  height: 1px;
}
/deep/
.tree-arrow.has-child:after {
  width: 5px;
  height: 5px;
}
/deep/
.tree-anchor {
    color: #fff;
}
/deep/
.tree-node.selected>.tree-content {
    background-color: #555;
}
/deep/
.tree-node:not(.selected)>.tree-content:hover {
    background-color: #444;
}
</style>
